module.exports = __webpack_public_path__ + "static/media/yes_pleats.dede3e50.svg";